/* script.default.js */

/* Icon-CSS über JS laden: Rollup löst url() zu ../Fonts/icons.* wie bei Roboto */
import "../assets/IconFont/icons.css";
import "../styles-entry.css";
import '../SCSS/_post-tailwind.scss';

// import Alpine.js
import Alpine from 'alpinejs'
// call Alpine
window.Alpine = Alpine

import eventTrigger from './components/eventTrigger'
import swiper from './components/swiper';
import priceCalculator from "./components/priceCalculator";
import faqController from "./components/faqController";
import tracking from "./components/tracking";
import { news } from "./components/news";
import { featureTableClampableText } from "./components/featureTableClampableText";
import anchorScroll from "./components/anchorScroll";
import fbcLink from "./components/fbcLink";

// init news component
news();
featureTableClampableText();

// start Alpine
Alpine.start()

// AOS - Animate on scroll library
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

document.addEventListener('DOMContentLoaded', function () {
    eventTrigger();
    swiper();
    priceCalculator();
    faqController();
    anchorScroll();
    tracking();
    fbcLink();
    if (document.querySelector('.pricing-model-desktop')) {
        pricingModelDesktop();
        window.addEventListener('resize', pricingModelDesktop);
    }
    document.querySelectorAll("img").forEach(img => {
        img.addEventListener("load", () => {
            AOS.refresh();
        });
    });
});

function pricingModelDesktop() {
    const pricingModelCE = document.querySelector('.pricing-model-desktop');
    const pricingModelCEItems = pricingModelCE.querySelectorAll('.pricing-model');
    let highlightPosition = undefined;
    let maxHeightNotHighlighted = 0;
    for (let i = 0; i < pricingModelCEItems.length; i++) {
        pricingModelCEItems[i].style.minHeight = 'unset';
        pricingModelCEItems[i].style.height = 'unset';
        if (pricingModelCEItems[i].classList.contains('model-highlight')) {
            highlightPosition = i;
        } else {
            if (pricingModelCEItems[i].offsetHeight > maxHeightNotHighlighted) {
                maxHeightNotHighlighted = pricingModelCEItems[i].offsetHeight;
            }
        }
    }
    // Models have the same height and rounded borders only on the outside
    if (highlightPosition === undefined) {
        pricingModelCEItems[0].style.borderTopRightRadius = '0';
        pricingModelCEItems[0].style.borderBottomRightRadius = '0';
        if (pricingModelCEItems.length === 2) {
            pricingModelCE.querySelector('#divider-2').style.display = "block";
        }
        if (pricingModelCEItems.length === 3) {
            pricingModelCE.querySelector('#divider-1').style.display = "block";
            pricingModelCE.querySelector('#divider-3').style.display = "block";
        }
    }
    if (highlightPosition === 0 || highlightPosition === undefined) {
        if (pricingModelCEItems.length === 2) {
            pricingModelCEItems[1].style.borderTopLeftRadius = '0';
            pricingModelCEItems[1].style.borderBottomLeftRadius = '0';
        }
        if (pricingModelCEItems.length === 3) {
            pricingModelCEItems[1].style.borderRadius = '0';
            pricingModelCEItems[2].style.borderTopLeftRadius = '0';
            pricingModelCEItems[2].style.borderBottomLeftRadius = '0';
            pricingModelCEItems[1].style.height = maxHeightNotHighlighted + 'px';
            pricingModelCEItems[2].style.height = maxHeightNotHighlighted + 'px';
        }
    }
    if (highlightPosition === 0) {
        pricingModelCEItems[0].style.minHeight = maxHeightNotHighlighted + 60 + 'px';
    }
    if (highlightPosition === 1) {
        pricingModelCEItems[0].style.borderTopRightRadius = '0';
        pricingModelCEItems[0].style.borderBottomRightRadius = '0';
        pricingModelCEItems[1].style.minHeight = maxHeightNotHighlighted + 60 + 'px';
        if (pricingModelCEItems.length === 3) {
            pricingModelCEItems[2].style.borderTopLeftRadius = '0';
            pricingModelCEItems[2].style.borderBottomLeftRadius = '0';
            pricingModelCEItems[0].style.height = maxHeightNotHighlighted + 'px';
            pricingModelCEItems[2].style.height = maxHeightNotHighlighted + 'px';
        }
    }
    if (highlightPosition === 2) {
        pricingModelCEItems[0].style.borderTopRightRadius = '0';
        pricingModelCEItems[0].style.borderBottomRightRadius = '0';
        pricingModelCEItems[1].style.borderRadius = '0';
        pricingModelCEItems[2].style.minHeight = maxHeightNotHighlighted + 60 + 'px';
        pricingModelCEItems[0].style.height = maxHeightNotHighlighted + 'px';
        pricingModelCEItems[1].style.height = maxHeightNotHighlighted + 'px';
    }
}
